import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import {LeftpanelComponent} from '../../../leftpanel/leftpanel.component';
import {ConfService} from '../../../conf.service';
import {MatSnackBar} from '@angular/material';
import {ConnecttocrudService} from '../../../connecttocrud.service';
import {EmailtemplateService} from '../../../emailtemplate.service';
import {environment} from '../../../../environments/environment';

import { MatSelect } from '@angular/material/select';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-add-user-environment',
  templateUrl: './add-user-environment.component.html',
  styleUrls: ['./add-user-environment.component.scss']
})
export class AddUserEnvironmentComponent implements OnInit {

  selectedEnvironmentList: any;
  environmentList: string[];
  password: any;
  shash: any;
  ralam: any;
  encyptedPassword: any;
  partnerShortName: any;
  @ViewChild('selectedElements') selectedElements: MatSelect;

  constructor(
      public platform: LeftpanelComponent,
      public dialog: MatDialog,
      private confPost: ConfService,
      private _snackBar: MatSnackBar,
      public _service: ConnecttocrudService,
      public emailTemplateInstance: EmailtemplateService,
      public dialogRef: MatDialogRef<AddUserEnvironmentComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  unselectOption(option: any) {


    // const optionElem = this.selectedElements.options.find(elem => elem.value === option);
    // if (optionElem) {
    //   optionElem.selected = false;
    // }
  }

  removeEnvironment(env: any) {
    const index = this.selectedEnvironmentList.indexOf(env);
    if (index >= 0) {
      this.selectedEnvironmentList.splice(index, 1);

    }
    this.unselectOption(env);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  // onAddEnvironment(): void {
  //   this.dialogRef.close(this.form.value);
  // }

  createRoleForEachEnvironment(roleDetail) {
    return new Promise((resolve, reject) => {
      this._service.addItem(roleDetail, 'v1', environment.accessPartner, environment.accessPartner, 'roles').subscribe(data => {
        if (data) {
          resolve(data['upsertedId']);
        } else {
          resolve('failed');
        }
      }, error => {
        resolve('failed');
      });
    });
  }

  addEnvironment() {
    if (this.password && this.password !== undefined) {
      this.platform.passwordPolicyValidator(this.password).then(status => {
        if (status) {
          const iterationCount = 1000;
          let keySize = 128;
          keySize = keySize / 32;
          const passphrase = environment.cipheringPhrase;
          const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
          const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
          const cipherText = this.platform.encrypt(salt, iv, passphrase, this.password, keySize, iterationCount);
          this._service.getItemswithParameter('v1',
              environment.accessPartner,
              environment.accessPartner,
              'users',
              'id=' + this.data['id']).subscribe(async result => {
            if (result) {
              const userResponse = result[0];

              for (const environment of this.selectedEnvironmentList) {
                const roleDetails = {
                  'role': environment + '=>' + environment + '=>' + this.data['emailId'],
                  'permission_groups': [],
                  'permissions': [],
                  'roles': [],
                  'exclusions': [],
                  'partner': environment,
                  'account': environment,
                  'type': 'account'
                };
                const roleId = await this.createRoleForEachEnvironment(roleDetails);
                userResponse['environments'].push(
                    {
                      name: environment,
                      account: environment,
                      roles: [roleId],
                      exclusions: {
                        permissions: [],
                        permission_groups: [],
                        roles: []
                      },
                      audit_logs: [
                        {
                          action: 'UPDATE',
                          by: localStorage.getItem('signInEmail'),
                          at: Date.now()
                        }
                      ],
                      password: cipherText,
                      shash: salt,
                      ralam: iv
                    }
                );


              }
              this._service.patchItemUpdate(this.data['id'],
                  {environments: userResponse['environments']},
                  'v1',
                  environment.accessPartner,
                  environment.accessPartner,
                  'users').subscribe(res => {
                if (res) {
                  this.dialogRef.close('success');
                }
              });
            }
          });
        } else {
          this.platform.openSnackBar(' Please make sure that your password follows our password policy ', 'Error', {
            duration: 2000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      });
    }

  }

  ngOnInit() {
    this.partnerShortName = localStorage.getItem('partner').split('-');
    this.environmentList = this.data['environmentList'];
  }


}
